import moment from 'moment';

export default [
	{
		name: 'Name',
		field: 'name',
		width: 'large',
		prepData: (mem) => {
			return `${mem.first_name} ${mem.last_name}`
		}
	},
	{
		name: 'Gender',
		field: 'gender',
		width: 'medium'
	},
	{
		name: 'Birthday',
		field: 'birthday',
		width: 'medium',
		prepData: (mem) => {
			if (mem.birthday) return moment(mem.birthday).format('MMM D, YYYY');
			else return ''
		}
	},
	{
		name: 'Email',
		field: 'email',
		width: 'large'
	},
	{
		name: 'Phone',
		width: 'medium',
		field: 'phone'
	}
]



/** WEBPACK FOOTER **
 ** ./src/tables/members.js
 **/